<template>
  <v-row>
    <v-col cols="12" md="6" :hidden="success || submitError">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-text-field
          v-model="name"
          :counter="10"
          :rules="nameRules"
          label="Organization Name"
          required
        ></v-text-field>

        <v-text-field
          v-model="website"
          :rules="websiteRules"
          label="Organization Website"
          required
        ></v-text-field>

        <v-text-field
          v-model="contact_name"
          :rules="contactNameRules"
          label="Contact Name"
          required
        ></v-text-field>

        <v-text-field
          v-model="email"
          :rules="emailRules"
          label="Contact E-mail"
          required
        ></v-text-field>

        <v-checkbox
          v-model="checkbox"
          :rules="[v => !!v || 'You must agree to continue!']"
          label="I agree to the Terms and Conditions"
          required
        ></v-checkbox>

        <v-btn
          :disabled="!valid"
          color="success"
          @click="submit"
        >
          Sign Up
        </v-btn>
      </v-form>
    </v-col>
    <v-col cols="12" md="6">
      <p :hidden="!success">Thank you! We have received your information, and we will notify you as soon as DoleFund is available.</p>
      <p :hidden="!submitError">Oops, something went wrong Please contact us directly at <a href="mailto:hello@dolefund.com?subject=SignUp">hello@dolefund.com</a></p>
    </v-col>
  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'OrganizationSignUpForm',

    data: () => ({
      submitted: false,
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'First name is required',
        v => (v && v.length <= 10) || 'First name must be less than 10 characters'
      ],
      website: '',
      websiteRules: [
        v => !!v || 'Website is required',
        v => /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi.test(v) || 'Must be a valid URL. Example: myorganization.org'
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      contact_name: '',
      contactNameRules: [
        v => !!v || 'Contact name is required',
        v => (v && v.length >= 2) || 'The contact name must be longer than 2 characters'
      ],
      select: null,
      checkbox: false,
      success: false,
      submitError: false
    }),

    mounted: () => {
      // Wake the API up
      axios.get('http://api.dolefund.com')
    },

    methods: {
      submit () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }

        this.submitted = true
        const vm = this

        // Get the ReCAPTCHA token before submitting
        window.grecaptcha.ready(function() {
          window.grecaptcha
            .execute('6LfoV6cZAAAAAMJzxyB1nL6RWW9yiRoO6Dt4cjWC')
            .then(token => {
              const data = {
                email: vm.email,
                first_name: vm.first_name,
                last_name: vm.last_name,
                name: vm.name,
                website: vm.website,
                token
              }

              axios
                .post('http://localhost:8000/api/organizations/', data)
                .then(() => {
                  vm.success = true
                })
                .catch(() => {
                  vm.submitError = true
                  // console.error('Failed to submit', error)
                  // console.error('This.submiterror?', vm.submitError)
                });
            })
            .catch(() => {
              vm.submitError = true
              // console.error('reCAPTCHA failed')
            })
        })
      }
    }
  }
</script>